"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var clone = require('clone');

var tv4 = require('tv4');

var Card = require('./card');

var TableItemSchema = require('./table-item-schema');

var TableCard = /*#__PURE__*/function (_Card) {
  _inherits(TableCard, _Card);

  var _super = _createSuper(TableCard);

  function TableCard(opt) {
    var _this;

    _classCallCheck(this, TableCard);

    _this = _super.call(this, opt);
    _this.type = 'TABLE';
    _this.details = {
      description: null,
      schema: [],
      items: [],
      canAddRows: true,
      layout: 'TABLE'
    };

    if (opt && opt.details) {
      _this.fillObject(clone(opt.details));
    }

    return _this;
  }

  _createClass(TableCard, [{
    key: "fillObject",
    value: function fillObject(details) {
      var _this2 = this;

      this.details.description = details.description || null;
      this.details.items = details.items || [];
      this.details.canAddRows = 'canAddRows' in details ? details.canAddRows : true;
      this.details.layout = details.layout || 'TABLE';

      if (details.schema) {
        details.schema.forEach(function (i) {
          var schema = new TableItemSchema(i);

          _this2.details.schema.push(schema);

          if (schema.type === 'DATE') {
            _this2.details.items.forEach(function (item) {
              if (item[schema.key]) {
                item[schema.key] = new Date(item[schema.key]); // eslint-disable-line
              }
            });
          }
        });
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, TableCard.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'table-card.schema.json',
        type: 'object',
        allOf: [{
          $ref: 'card.schema.json'
        }, {
          properties: {
            details: {
              description: {
                type: ['string', 'null']
              },
              schema: {
                type: 'array',
                items: {
                  $ref: 'table-item-schema.schema.json'
                }
              },
              items: {
                type: 'array',
                items: {
                  type: 'object'
                }
              },
              canAddRows: {
                type: 'boolean'
              },
              layout: {
                type: 'string',
                "enum": ['TABLE', 'VERTICAL']
              }
            }
          }
        }],
        required: Object.keys(this)
      };
    }
  }]);

  return TableCard;
}(Card);

tv4.addSchema(Card.schema());
tv4.addSchema(TableItemSchema.schema());
module.exports = TableCard;